export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return

  const protectedRoutes = ['/hesap', '/management', '/tuccar/basvuru']
  const managementLoginPath = '/management/login'
  const isManagementRoute = to.path.startsWith('/management')
  const isManagementLogin = to.path.startsWith(managementLoginPath)

  if (isManagementLogin) return

  if (protectedRoutes.some((route) => to.path.startsWith(route))) {
    const auth = useAuth()

    if (auth.status.value !== 'authenticated') {
      await auth.getSession()
    }

    if (auth.status.value !== 'authenticated') {
      return navigateTo(isManagementRoute ? managementLoginPath : `/auth?callback=${to.fullPath}`)
    }

    if (isManagementRoute) {
      const role = auth.data.value?.user?.role
      if (!['vendor', 'admin'].includes(role)) {
        return navigateTo(managementLoginPath)
      }
    }
  }
})
